import { connect } from 'react-redux'
import SlideFooter from './slide-footer.jsx'
import { updateNotes } from '../../../../../stores/presentation/presentation.actions.js'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getSlide } from '../../../../../stores/presentation/presentation.selectors.js'

const mapStateToProps = (state, { id }) => {
  const slide = getSlide(state, id)
  return {
    privateNote: slide.private_note,
    publicNote: slide.public_note
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onSubmit: values =>
    dispatch(updateNotes(ownProps.id, values)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SlideFooter)
